import React from "react";

const Error = () => {
  return <div>ERROR! PAGE NOT FOUND</div>;
};

export default Error;
